export default "__VITE_ASSET__BdCOCNqr__"